import type { StoreState } from 'src/store/types';

export * from './accounts'; // includes selectSite
export * from './invoices';
export * from './payment';
export * from './user';
export * from './view';

export const selectAuthenticationStatus = (state: StoreState) =>
  state.authenticationStatus;
export const selectEnvironment = (state: StoreState) => state.environment;
export const selectLocale = (state: StoreState) => state.locale;
